let elements = {
  //pick: 3,
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page039_game0/img/bcg1.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page039_game0/audio/false.mp3',
    // positive: 'games/page039_game0/audio/empty_true.mp3',
    click: 'games/page039_game0/audio/click.mp3',
    icon: {
      on: 'games/page039_game0/img/audioOn.png',
      off: 'games/page039_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 20,
    height: 20,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 278,
    height: 379,
  },
  layoutItems: [
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 1621,
        y: 129,
      },
    },
    {
      pos: {
        x: 1621,
        y: 387,
      },
    },
  ],
  shuffle: true,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page039_game0/audio/55_parrot.mp3',

          correct: {
            image: {
              src: 'games/page039_game0/img/papuga.webp',
            },
            width: 257,
            height: 326,
            correctItems: {
              images: [
                {
                  src: 'games/page039_game0/img/papugaok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 257,
                  height: 326,
                },
              ],
              text: [],
            },
          },
        },
        {
          // audioSrc: 'games/page039_game0/audio/54_hamster.mp3',
          alwaysCorrect: true,

          correct: {
            image: {
              src: 'games/page039_game0/img/chomik.webp',
            },
            width: 278,
            height: 379,
            incorrectItems: {
              images: [
                {
                  src: 'games/page039_game0/img/chomikwr.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 278,
                  height: 379,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  mbStaticAudioItemData: [
    {
      id: 'a01',
      src: 'games/page039_game0/audio/54_hamster.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page039_game0/img/audioOn.png', iconOff: 'games/page039_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 610,
        x: 115 + 325 * 0,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page039_game0/audio/55_parrot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page039_game0/img/audioOn.png', iconOff: 'games/page039_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 610,
        x: 115 + 325 * 1,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page039_game0/audio/54_hamster.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page039_game0/img/audioOn.png', iconOff: 'games/page039_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 610,
        x: 115 + 325 * 2,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: 'games/page039_game0/audio/55_parrot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page039_game0/img/audioOn.png', iconOff: 'games/page039_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 610,
        x: 115 + 325 * 3,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      id: 'a05',
      src: 'games/page039_game0/audio/54_hamster.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page039_game0/img/audioOn.png', iconOff: 'games/page039_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 610,
        x: 115 + 325 * 4,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
  ],
};

export default elements;
